function Banner() {
    return (
        <div className="banner-image-container">
            <img className="banner-image" src="movie-banner.jpeg" alt="banner"/>
        </div>
    )
}

export default Banner